import { useEffect, useState } from 'react';
import { resolveFileFieldValue } from '@common/utils/resolveFileUrl';

export function useResolvedFileUrl(
  value: string | { url?: string } | null | undefined
): string | null {
  const [resolvedUrl, setResolvedUrl] = useState<string | null>(null);
  const dep = typeof value === 'string' ? value : value?.url;

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!value) {
        setResolvedUrl(null);
        return;
      }

      try {
        const url = await resolveFileFieldValue(value);
        if (!cancelled) setResolvedUrl(url);
      } catch {
        if (!cancelled) setResolvedUrl(null);
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [dep]);

  return resolvedUrl;
}
